// extracted by mini-css-extract-plugin
export var closeButton = "_5o-0";